import { render, staticRenderFns } from "./addNewBoard.vue?vue&type=template&id=50e6a6c9&"
import script from "./addNewBoard.vue?vue&type=script&lang=js&"
export * from "./addNewBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports